/**
 * 검색어와 이름을 <b>같은 모양으로</b> 다듬는다 (사용자 지적 2026-09-16: 「검색이 매끄럽지 않다」).
 *
 * <h2>띄어쓰기 한 칸에 막혀 있었다</h2>
 * 사이드바 검색은 소문자로만 바꿔 그대로 {@code includes} 했다. 그래서 <b>「권한진단」 을 치면
 * 「권한 진단」 이 안 나왔다</b> — 「사용자권한」·「현장현황판」·「자재관리」 도 마찬가지였다.
 * 사람은 메뉴 이름의 띄어쓰기를 외우지 않는데, 검색은 그것을 정확히 요구하고 있었다.
 *
 * <p>가운뎃점도 같은 이유로 걷는다 — 「사용자·권한 관리」 는 <b>치기 어려운 글자</b>가 이름
 * 한가운데 박혀 있다. 「사용자권한관리」 로 찾을 수 있어야 한다.
 *
 * <h2>왜 한 곳에 두나</h2>
 * 쓰는 자리가 둘 이상이다 — 사이드바 메뉴 검색과 권한 진단의 메뉴 검색. 각자 두면 한쪽만 고쳐지는
 * 날 <b>같은 말을 쳤는데 화면마다 다른 결과</b>가 나온다.
 *
 * <p>★ <b>이름을 고치지 않는다.</b> 화면에 그리는 것은 원래 이름 그대로이고, 다듬은 값은 견주는
 *   동안에만 쓴다 — 여기서 바꾼 글자가 화면에 나가면 그때부터 이름이 두 벌이 된다.
 */
export function normalizeSearch(value: string): string {
  return value.toLowerCase().replace(/[\s·・‧⋅/_-]+/g, '');
}
